import {Component} from '@angular/core';
import {DynamicFormComponent, DynamicFormControlComponent} from 'frontier/browserkit';
import {NgIf} from '@angular/common';
import AppControlGuids from '../../../api/ControlGuids';
import {MatError} from '@angular/material/form-field';

@Component({
  selector: 'app-invoice-template-config-form',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.scss',
  standalone: true,
  imports: [NgIf, DynamicFormComponent, MatError],
})
export class InvoiceTemplateConfigFormComponent extends DynamicFormControlComponent {
  override GUID: string = AppControlGuids.TInvoiceTemplateConfigForm;
}
